import { Alert, AlertTitle, Avatar, Box, Button, CircularProgress, Container, IconButton, InputAdornment, styled, TextField, Typography } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit';
import { FormProvider, useForm } from 'react-hook-form';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import axiosClient from '../../../../lib/axios';
import { useNavigate } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import useBaseUrl from '../../../../lib/useBaseUrl';

export default function CadastrarCooperativa() {

    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const primeiroParam = useBaseUrl();

    const methods = useForm<TCooperativaInputs>()
    const { register, handleSubmit, watch, setValue, getFieldState, formState: { errors } } = methods;

    const [mostraSenha, setMostrarSenha] = useState(false)
    const [mostraConfirmSenha, setMostrarConfirmSenha] = useState(false)
    const [imagePreview, setImagePreview] = useState<string | null>(null)
    const [criterios, setCriterios] = useState<string[] | null>(null)
    setValue('dominio', primeiroParam)

    //queries e mutations
    const { mutate: cadastrarCooperativa, isLoading } = useMutation({
        mutationKey: 'cadastrar-cooperativa',
        mutationFn: (inputs: TCooperativaInputs) => axiosClient.post("/cadastrar-cooperativa", inputs, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        }),
        onError: ({ response }) => {
            if (response.data.critérios) {
                setCriterios(response.data.critérios)
            }
        },
        onSuccess: ({ data }) => {
            queryClient.invalidateQueries("pesquisar-imagem-cooperativa")
            enqueueSnackbar('Cooperativa cadastrada com sucesso!', { variant: 'success' });
            navigate("/login")
        },

    })
    //

    const onSubmit = (data: TCooperativaInputs) => {
        cadastrarCooperativa(data)
    }
    const handleChangeImage = (event: React.ChangeEvent<HTMLInputElement>) => {
        const novoArquivo = event.target.files && event.target.files[0];
        if (novoArquivo) {
            setValue("logo_image", novoArquivo, { shouldValidate: true })
            setImagePreview(URL.createObjectURL(novoArquivo))
        }
    }

    useEffect(() => {
        register("logo_image", { required: "A imagem logo é obrigatória" });
    }, [register]);

    return (
        <Container maxWidth="md" sx={{ paddingTop: 3 }}>
            <Box textAlign={'center'} mb={4}>
                <Typography variant='h5' fontWeight={'bold'}>Seja bem vindo! Identificamos que é o primeiro acesso</Typography>
                <Typography variant='body1' fontWeight={'bold'}>Vamos iniciar a configuração do Sistema Techpines na sua cooperativa!</Typography>
            </Box>

            <Box display={'flex'} justifyContent={'center'} flexDirection={'row'}>
                <FormProvider {...methods}>
                    <Box display={'flex'} flexDirection={'column'} alignItems={'center'} mr={8} mt={2}>
                        <Avatar
                            alt="Remy Sharp"
                            src={imagePreview ? imagePreview : '/imgs/image-not-found.png'}
                            sx={{ width: 150, height: 150 }}
                        />
                        <Box
                            component={'label'}
                            border={'none'}
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            bgcolor="#1b5e20"
                            width={35}
                            height={35}
                            borderRadius="50%"
                            ml={12}
                            mt={-3.5}
                            zIndex={1}
                            sx={{
                                alignSelf: "center",
                                cursor: "pointer"
                            }}
                        >
                            <EditIcon fontSize="small" sx={{ color: "white" }} />
                            <VisuallyHiddenInput onChange={(e) => handleChangeImage(e)} type="file" accept=".png, .jpg, .jpeg" />
                        </Box>
                        {errors.logo_image && (
                            <Box color="red" mt={1} textAlign={'center'}>
                                {errors.logo_image.message}
                            </Box>
                        )}
                    </Box>
                    <Box
                        display={'flex'}
                        flexDirection={'column'}
                        width={'80%'}
                        component={'form'}
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="nome_cooperativa"
                            label="Nome da cooperativa"
                            {...register("nome_cooperativa")}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            type='number'
                            id="cnpj"
                            label="CNPJ"
                            {...register("cnpj", {
                                maxLength:
                                {
                                    value: 14,
                                    message: 'O CNPJ deve ter exatamente 14 dígitos.'
                                },
                                minLength: {
                                    value: 14,
                                    message: 'O CNPJ deve ter exatamente 14 dígitos.'
                                },
                                required: "O campo CNPJ é obrigatório."
                            })}
                            error={getFieldState("cnpj").invalid}
                            helperText={
                                getFieldState("cnpj").error?.message || ""
                            }
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="incricao_estadual"
                            label="Inscrição estadual"
                            {...register("incricao_estadual")}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="razao_social"
                            label="Razão social"
                            {...register("razao_social")}
                        />
                        <Typography mt={2} mb={-2} variant='subtitle2' fontWeight={'bold'}>Usuário administrador</Typography>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email"
                            autoComplete="email"
                            {...register("email")}
                        />
                        {
                            !criterios && <Alert severity="warning">
                                Crie uma senha segura de 8 dígitos.
                            </Alert>
                        }
                        {
                            criterios &&
                            <Alert severity="warning" icon={false}>
                                <AlertTitle>Critérios de senha:</AlertTitle>
                                {criterios?.map((item, index) => (
                                    <p key={index}>{item} </p>
                                ))}
                            </Alert>
                        }
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="senha"
                            label="Senha"
                            type={mostraSenha ? "text" : "password"}
                            autoComplete="current-senha"
                            {...register("senha", { minLength: 6, required: true })}
                            error={getFieldState("senha").invalid}
                            helperText={
                                getFieldState("senha").error?.message || ""
                            }
                            slotProps={{
                                input: {
                                    endAdornment:
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => setMostrarSenha(prevState => !prevState)}
                                            >
                                                {mostraSenha ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                }
                            }}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            type={mostraConfirmSenha ? "text" : "password"}
                            id="senha_confirmation"
                            label="Confirmar Senha"
                            autoComplete="current-senha"
                            {...register("senha_confirmation", {
                                minLength: 6, required: true,
                                validate: (value) => value === watch("senha") || "As senhas devem ser iguais"
                            })}
                            error={getFieldState("senha_confirmation").invalid}
                            helperText={
                                getFieldState("senha_confirmation").error?.message || ""
                            }
                            slotProps={{
                                input: {
                                    endAdornment:
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => setMostrarConfirmSenha(prevState => !prevState)}
                                            >
                                                {mostraConfirmSenha ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                }
                            }}
                        />
                        <Button sx={{ alignSelf: 'flex-end', marginTop: 2 }} type='submit' variant='contained'>
                            {isLoading && (
                                <CircularProgress size={14} style={{ marginRight: 12 }} />
                            )}{" "}
                            Configurar
                        </Button>
                    </Box>

                </FormProvider>
            </Box>
        </Container>
    )
}

type TCooperativaInputs = {
    nome_cooperativa: string
    cnpj: string,
    razao_social: string,
    email: string,
    senha: string,
    senha_confirmation: string,
    logo_image: File,
    dominio: string,
    incricao_estadual: string
}

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});